import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";

export class RecurringServicesTableCtrl implements IController {
  infiniteScroll: any;
  queryString: any;
  selectedIds: any;
  isScrollable: any;
  enableAccountColumn?: boolean;
  selectedIdsChanged: Function;
  onEdit: Function;
  onDuplicate: Function;
  onDelete: Function;

  private selectedKeys: any;
  private expandedKeys: any;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    this.selectedKeys = {};
    this.expandedKeys = {};

    _.forEach(this.selectedIds, (selectedId) => {
      this.selectedKeys[selectedId] = true;
    });
  }

  $onChanges(changes) {
    if (changes.selectedIds && !changes.selectedIds.isFirstChange()) {
      this.$onInit();
    }
  };

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  toggleService(serviceId) {
    this.selectedKeys[serviceId] = !this.selectedKeys[serviceId];
    const selectedIds = _.map(this.selectedKeys, (value, key) => {
      if (value) return key;
    });
    this.selectedIdsChanged({ids: _.compact(selectedIds)});
  }

  // onToggleAllServices() {
  //   const selectedIds = !_.isEqual(this.selectedIds.length, this.services.length) ?
  //     _.map(this.services, (s) => {
  //       return s.id;
  //     }) : [];
  //
  //   // ctrl.selectedIdsChanged({ids : _.compact(selectedIds)});
  //   this.selectedIdsChanged({ids: selectedIds});
  // }

  onExpand(serviceId) {
    this.expandedKeys[serviceId] = !this.expandedKeys[serviceId];
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('recurringServicesTable', {
    bindings: {
      infiniteScroll: '<',
      queryString: '<',
      selectedIds: '<',
      isScrollable: '<?',
      enableAccountColumn: '<?',
      selectedIdsChanged: '&',
      onEdit: '&',
      onDuplicate: '&',
      onDelete: '&'
    },
    template: require('./recurring-services-table.html').default,
    controller: RecurringServicesTableCtrl
  });
